<template>
  <EntitySingle
    :config="config"
    :entity.sync="entity"
    :loaded.sync="entityLoaded"
  >
    <b-card v-if="entityLoaded">
      <b-tabs pills>
        <!-- Tab: Information -->
        <b-tab active>
          <template #title>
            <feather-icon
              icon="InfoIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
          </template>
          <EntityEditSection
            :module="config.module"
            :entity.sync="entity"
            :form-fields="infoFormFields"
            allow-autofocus
          />
        </b-tab>
        <!-- Tab: Questions -->
        <b-tab
          v-if="entity.id > 0"
          lazy
        >
          <template #title>
            <feather-icon
              icon="FolderIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('Questions') }}</span>
          </template>
          <QuestionsList
            :module="config.module"
            :parent-entity.sync="entity"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </EntitySingle>
</template>

<script>
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'
import EntitySingle from '@/layouts/entity/EntitySingle.vue'
import QuestionsList from './QuestionsList.vue'
import { translationUtils } from '@core/mixins/ui/translations'
import storeModule from './storeModule'

export default {
  components: {
    EntityEditSection,
    EntitySingle,
    QuestionsList,
  },
  mixins: [translationUtils],
  data() {
    return {
      entity: {
        enabled: true,
      },
      entityLoaded: false,
      categoryOptions: [],
      workingGroupOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'poll',
        endpoint: 'poll',
        route: 'votes',
        title: {
          single: this.$t('Vote Add'),
          plural: this.$t('Votes'),
        },
      }
    },
    infoFormFields() {
      return [
        {
          id: 'title',
          type: 'text',
          label: this.$i18n.t('Title'),
          required: true,
          rules: 'min:3',
          colSize: 6,
        },
        {
          id: 'category',
          type: 'select',
          object: true,
          label: this.$i18n.t('Category'),
          required: false,
          options: this.categoryOptions,
          colSize: 6,
        },
        {
          id: 'startDate',
          type: 'datetime',
          label: this.$t('Start Date'),
          refMaxDate: 'endDate',
          required: true,
          colSize: 4,
        },
        {
          id: 'endDate',
          type: 'datetime',
          label: this.$t('End Date'),
          refMinDate: 'startDate',
          required: true,
          colSize: 4,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('enabled'),
          colSize: 2,
        },
        {
          id: 'description',
          type: 'quill',
          label: this.$t('description'),
          colSize: 12,
        },
        {
          id: 'groups',
          type: 'selectmultiple',
          label: this.$t('Working Groups'),
          options: this.workingGroupOptions,
          colSize: 12,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchPollCategories').then(response => {
      this.categoryOptions = response.data
    })
    this.$store.dispatch('app-common/fetchWorkingGroups').then(response => {
      this.workingGroupOptions = response.data
    })
  },
}
</script>
